import { render } from "./Vat_Transactions.vue?vue&type=template&id=777a5dda"
import script from "./Vat_Transactions.vue?vue&type=script&lang=js"
export * from "./Vat_Transactions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__